import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ecde14e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents" }
const _hoisted_2 = { class: "table area-password" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { "aria-live": "polite" }, [
  /*#__PURE__*/_createTextVNode(" 現在のパスワード "),
  /*#__PURE__*/_createElementVNode("span", { class: "label required" }, "必須")
], -1))
const _hoisted_5 = { "aria-live": "polite" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode(" 新しいパスワード "),
  /*#__PURE__*/_createElementVNode("span", { class: "label required" }, "必須")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { "aria-live": "polite" }, [
  /*#__PURE__*/_createTextVNode(" 新しいパスワード（確認） "),
  /*#__PURE__*/_createElementVNode("span", { class: "label required" }, "必須")
], -1))
const _hoisted_8 = { class: "area-apiMsg" }
const _hoisted_9 = { class: "navigation" }
const _hoisted_10 = { class: "navigation-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " TOPへ戻る ", -1))
const _hoisted_12 = { class: "navigation-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 変更する ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_TextAlert = _resolveComponent("TextAlert")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _hoisted_3,
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _createVNode(_component_AppInput, {
              modelValue: _ctx.currentPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event)),
              type: "password",
              label: "現在のパスワード",
              onBlur: _ctx.currentPassCheck,
              inputId: 'input-currentPassword'
            }, null, 8, ["modelValue", "onBlur"]),
            (_ctx.currentPasswordMessage)
              ? (_openBlock(), _createBlock(_component_TextAlert, {
                  key: 0,
                  class: _normalizeClass('errMsg-currentPassword')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentPasswordMessage), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("td", null, [
            _createVNode(_component_AppInput, {
              modelValue: _ctx.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
              type: "password",
              label: "新しいパスワード",
              onBlur: _ctx.newPassCheck,
              inputId: 'input-newPassword'
            }, null, 8, ["modelValue", "onBlur"]),
            _createElementVNode("hr", {
              class: "scoreBar",
              style: _normalizeStyle({ 'background-color': _ctx.barColor, 'width': _ctx.barWidth})
            }, null, 4),
            (_ctx.newPasswordMessage)
              ? (_openBlock(), _createBlock(_component_TextAlert, {
                  key: 0,
                  class: _normalizeClass('errMsg-newPassword')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.newPasswordMessage), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", null, [
            _createVNode(_component_AppInput, {
              modelValue: _ctx.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkPassword) = $event)),
              type: "password",
              label: "新しいパスワード（確認）",
              onBlur: _ctx.checkPassCheck,
              inputId: 'input-checkPassword'
            }, null, 8, ["modelValue", "onBlur"]),
            (_ctx.checkPasswordMessage)
              ? (_openBlock(), _createBlock(_component_TextAlert, {
                  key: 0,
                  class: _normalizeClass('errMsg-checkPassword')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.checkPasswordMessage), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.apiMsg), 1),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_AppButton, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push('/dms/outer'))),
          onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/outer')), ["prevent"]), ["space","enter"])),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.update,
          onKeydown: _withKeys(_withModifiers(_ctx.update, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          buttonId: 'button-next'
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ])
    ])
  ]))
}